import React, { useState } from "react"
import * as styles from "./EbookHeroSection.module.scss"

const EbookHeroSection = ({ data }) => {
  const {
    title,
    subHeading,
    bulletPoints,
    metaInfo,
    formTitle,
    emailPlaceholder,
    checkboxText,
    buttonLabel,
    successMessage,
    bookFile,
    coverImage,
  } = data

  const [email, setEmail] = useState("")
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState("")
  const [isChecked, setIsChecked] = useState(false)

  const handleSubmit = e => {
    e.preventDefault()
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address")
      return
    }
    setError("")
    setSubmitted(true)

    if (bookFile?.file?.url) {
      window.open(bookFile.file.url, "_blank")
    }
  }

  return (
    <section className={`${styles.heroSection} container c-padding c-padding-block}`}>
        {/* Left Content */}
        <div className={styles.left}>
          <h1>{title}</h1>
          {subHeading && <p className={styles.subtitle}>{subHeading}</p>}
          {bulletPoints && bulletPoints.length > 0 && (
            <ul className={styles.points}>
              {bulletPoints.map((point, idx) => (
                <li key={idx}>{point}</li>
              ))}
            </ul>
          )}
          {metaInfo && <p className={styles.meta}>{metaInfo}</p>}
        </div>

        {/* Right Form */}
        <div className={styles.right}>
          {!submitted ? (
            <form onSubmit={handleSubmit} className={styles.form}>
              <label htmlFor="email">{formTitle }</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder={emailPlaceholder}
                required
              />
              {error && <p className={styles.error}>{error}</p>}

              <div className={styles.checkboxWrapper}>
                <input
                  type="checkbox"
                  id="terms"
                  checked={isChecked}
                  onChange={e => setIsChecked(e.target.checked)}
                />
                <label htmlFor="terms">
                  {checkboxText }
                </label>
              </div>

              <button
                type="submit"
                disabled={!isChecked}
                className={`${styles.submitButton} ${
                  !isChecked ? styles.disabled : ""
                }`}
              >
                { "Download eBook"}
              </button>
            </form>
          ) : (
            <p className={styles.success}>
              {successMessage}
            </p>
          )}
        </div>
    </section>
  )
}

export default EbookHeroSection